import { FC, ReactElement, ReactNode } from 'react';

import { Box } from '@mui/material';

import AuthHeader from './Auth.header';
import AuthFooter from './Auth.footer';

interface AuthLayoutProps {
  children: ReactNode | ReactElement;
}

const AuthLayout: FC<AuthLayoutProps> = ({ children }): ReactElement => {
  return (
    <Box width="100%" display="flex" flexDirection="column">
      <AuthHeader />
      <main style={{ display: 'flex', flex: 1 }}>{children}</main>
      <AuthFooter />
    </Box>
  );
};

export default AuthLayout;
